import { useEffect, useState } from 'react';
// import Data from '../components/Data';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  gridAnimation,
  cardAnimation,
  h3Animation,
} from '../components/Animations';

import { collection, onSnapshot, orderBy, query } from '@firebase/firestore';
import { db } from '../config/firebaseConfig';

// import MenuItem from "@mui/material/MenuItem";
// import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";

const Cars = ({ data, resultsFound }) => {
  const [posts, setPosts] = useState([]);

  // get data from fireStore
  useEffect(
    () =>
      onSnapshot(
        query(collection(db, 'carPost'), orderBy('timestamp', 'desc')),
        (snapshot) => {
          setPosts(
            snapshot.docs?.map((doc) => {
              return {
                id: doc.id,
                ...doc.data(),
              };
            })
          );
        }
      ),
    []
  );

  if (!resultsFound)
    return (
      <div
        style={{
          width: '100%',
          height: '50vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <h1>No results found</h1>
      </div>
    );
  return (
    <div className="carsContainer">
      <motion.div
        className="cars"
        variants={gridAnimation}
        animate="show"
        exit="hide"
      >
        {data?.map((item) => {
          return (
            <Link
              to={`/car/${item.id}`}
              key={item.id}
              style={{
                linkStyle: 'none',
                textDecoration: 'none',
                color: '#5e5e5e',
                fontSize: '1.5rem',
                fontWeight: 'bold',
              }}
            >
              <motion.div variants={cardAnimation} className="card">
                <div>
                  <img
                    src={item?.featureLink && item?.featureLink[0]}
                    loading="lazy"
                    alt={item.brand}
                  />
                </div>
                <motion.p variants={h3Animation} animate="show" exit="hide">
                  {item.brand}{' '}
                  <span
                    style={{
                      fontSize: '12px',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                    }}
                  >
                    {item.model}
                  </span>{' '}
                  <br />
                  <motion.small
                    variants={h3Animation}
                    animate="show"
                    exit="hide"
                  >
                    {item.mileage}cc - {item.transmission}
                  </motion.small>
                </motion.p>
              </motion.div>
            </Link>
          );
        })}
      </motion.div>
    </div>
  );
};

export default Cars;
